module.exports = __webpack_public_path__ + "refresh.svg?1793698113381";